import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl font-heading font-bold text-primary-400">51</span>
                <span className="text-lg font-heading font-bold text-background-50">漫画网</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                {siteInfo.slogan}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
              <ul className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <p className="text-sm text-background-300">
                    邮箱：{siteInfo.contact.email}
                  </p>
                </li>
                <li>
                  <p className="text-sm text-background-300">
                    微信：{siteInfo.contact.wechat}
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 51漫画网 - 韩漫免费在线阅读平台。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                关于我们
              </Link>
              <Link to="/" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                首页
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}